export default __webpack_public_path__ + "static/media/tushar.795eebcd.jpeg";